<template>
  <NotificationHost>
    <template #default>
      <q-layout view="lHh LpR lFf" class="mainLayout">
        <!-- меню на всю высоту (сверху логотип и «свернуть»), хедер справа от него; при закрытом меню ☰ и логотип — в хедере -->
        <Header :drawer-open="this.drawerOpen" @toggle-navbar="toggleDrawer" />
    <Navbar
      @toggle-navbar="toggleDrawer"
      :value="this.drawerOpen"
      @navbar_change="setDrawer"
    />
    <q-page-container>
      <div class="layout-page-wrapper">
        <q-page :padding="padding" class="layout-page">
          <router-view />
        </q-page>
      </div>
    </q-page-container>
    <!-- <ItSupportPanel /> -->
    <NexoraAssistant />
      </q-layout>
    </template>
  </NotificationHost>
</template>

<script>
import Header from "@/components/layout/Header";
import Navbar from "@/components/layout/Navbar";
// import ItSupportPanel from "@/components/it-support/ItSupportPanel.vue";
import NotificationHost from "@/components/notifications/NotificationHost.vue";
import NexoraAssistant from "@/components/nexora/NexoraAssistant.vue";
import {appActions} from "@/services/store/modules/app_module/app_actions";
import {LOCALSTORAGEFIELDS} from "@/constants";

export default {
  name: "layout",
  components: {Header, Navbar, /* ItSupportPanel, */ NotificationHost, NexoraAssistant},
  data() {
    return {
      // меню видно по умолчанию на широком экране (как show-if-above у q-drawer, порог Quasar 1023px)
      drawerOpen: typeof window !== "undefined" && window.innerWidth > 1023,
    }
  },
  props: {
    padding: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    // фактическое состояние меню (из q-drawer или по кнопке); стор синхронизируем — его читает,
    // например, генератор отчётов для расчёта ширины
    setDrawer(open) {
      if (this.drawerOpen === open) return
      this.drawerOpen = open
      if (this.$store.state.app.menuDrawerOpen !== open) this.$store.commit(appActions.toggleMenuDrawer())
      localStorage.setItem(LOCALSTORAGEFIELDS.menuDrawerOpen, open ? '1' : '0')
    },
    toggleDrawer() {
      this.setDrawer(!this.drawerOpen)
    },
  },
};
</script>

<style lang="scss">
// Раскладка как в app.buildest.kz: меню на всю высоту слева, хедер 48px справа от него,
// рабочая область вплотную к меню и хедеру, без внешних отступов и скруглений.
.mainLayout {
  & > .q-drawer-container > .q-drawer {
    border-right: 1px solid var(--ms-border);
  }
}
.layout-page-wrapper {
  & > .layout-page {
    background-color: var(--ms-surface);
    min-height: calc(100vh - var(--ms-header-h)) !important;

    &.q-layout-padding {
      padding: var(--ms-page-pad);
    }
  }
  @media (max-width: 576px) {
    & > .layout-page.q-layout-padding {
      padding: 8px;
    }
  }
}
</style>
